import { createSelector } from '@reduxjs/toolkit';
import { getCurrentUserEmail } from '../session';
import { getEmployeesAsUsers } from '../employees/get-employees-as-users';
import { getContactsAsUsers } from '../partners/get-contacts-as-users';

export const displayedUserName = createSelector(
  getEmployeesAsUsers,
  getContactsAsUsers,
  getCurrentUserEmail,
  function (employees, contacts, currentUserEmail) {
    if (!currentUserEmail) {
      return '';
    }

    const employeeAsUser = employees.find(
      (e) => e.email !== undefined && currentUserEmail.toLowerCase() === e.email.toLowerCase(),
    );
    const contactAsUser = contacts.find(
      (e) => e.email !== undefined && currentUserEmail.toLowerCase() === e.email.toLowerCase(),
    );

    let displayedUserName = '';

    if (employeeAsUser !== undefined) {
      displayedUserName = employeeAsUser.name;
    } else if (contactAsUser !== undefined) {
      displayedUserName = contactAsUser.name;
    }

    if (displayedUserName.length < 3) {
      displayedUserName = currentUserEmail;
    }

    return displayedUserName;
  },
);
